<template>
  <v-row dense>
    <v-col class="pt-2" cols="12">
      <v-text-field
        v-if="action === 'edit'"
        v-model="form.link_to_documentation"
        :readonly="readonly"
        :label="`${$t('CONTRACTS.LINK')} *`"
        :error-messages="errors.link_to_documentation"
        :rules="getRulesByName('info')"
        @input="updateValue('link_to_documentation', $event)"
      />

      <v-btn
        v-if="action === 'show'"
        text
        class="text-button"
        :disabled="!form.link_to_documentation"
        @click="redirectTo"
      >
        {{
          form.link_to_documentation
            ? $t('CONTRACTS.LINK')
            : $t('CONTRACTS.LINK_IS_ABSENT')
        }}
      </v-btn>
    </v-col>
    <v-col cols="12">
      <v-textarea
        v-model="form.info"
        outlined
        rows="2"
        :counter="1500"
        :label="`${$t('EMPLOYEES.ADDITIONAL_INFORMATION')}`"
        :readonly="readonly"
        :error-messages="errors.info"
        :rules="getRulesByName('info')"
        @input="updateValue('info', $event)"
    /></v-col>
  </v-row>
</template>

<script>
import formEditable from '@/modules/_global/mixins/form-editable';
import { maxLength, notEmoji } from '@/modules/_global/variables/rules';
import { startsWith } from 'lodash';

export default {
  name: 'AdditionalInfoForm',

  mixins: [formEditable],

  data() {
    return {
      form: {
        info: ''
      },
      rules: {
        info: [maxLength(1500), notEmoji]
      }
    };
  },

  methods: {
    redirectTo() {
      let link =
        startsWith(this.form.link_to_documentation, 'https://') || startsWith(this.form.link_to_documentation, 'http://')
          ? this.form.link_to_documentation
          : 'https://' + this.form.link_to_documentation;

      window.open(link, '_blank');
    }
  }
};
</script>
<style scoped>
.text-button {
  color: darkgreen;
  text-decoration: underline;
  cursor: pointer;
}
</style>
